import { request } from "@/api/server/index";

export default {
  //V015_案件詳細表示画面
  ProposalAllInfo: {
    //初期表示
    indexProposalAllInfo(params) {
      return request({
        url: "/proposalAllInfo/indexProposalAllInfo",
        data: params,
        method: "post"
      });
    },
    //添付書類リスト
    searchProposalAttachmentList(params) {
      return request({
        url: "/proposalAllInfo/searchProposalAttachmentList",
        data: params,
        method: "post"
      });
    },
    //予定リスト
    searchProposalTodoList(params) {
      return request({
        url: "/proposalAllInfo/searchProposalTodoList",
        data: params,
        method: "post"
      });
    },
    //履歴リスト
    searchProposalHistoryList(params) {
      return request({
        url: "/proposalAllInfo/searchProposalHistoryList",
        data: params,
        method: "post"
      });
    },
    //関連案件リスト
    searchRelatedProposalList(params) {
      return request({
        url: "/proposalAllInfo/searchRelatedProposalList",
        data: params,
        method: "post"
      });
    },
    //添付書類削除
    deleteProposalAttachment(params) {
      return request({
        url: "/proposalAllInfo/deleteProposalAttachment",
        data: params,
        method: "post"
      });
    }, //関連案件削除
    deleteRelatedProposal(params) {
      return request({
        url: "/proposalAllInfo/deleteRelatedProposal",
        data: params,
        method: "post"
      });
    },
    //関連案件登録ダイアログ初期表示
    indexRelatedProposalEdit(params) {
      return request({
        url: "/proposalAllInfo/indexRelatedProposalEdit",
        data: params,
        method: "post"
      });
    },
    //案件詳細情報 関連案件選択時の処理
    insertRelatedProposal(params) {
      return request({
        url: "/proposalAllInfo/insertRelatedProposal",
        data: params,
        method: "post"
      });
    },
    //添付書類ダウンロード
    downloadProposalAttachment(params) {
      return request({
        url: "/proposalAllInfo/downloadProposalAttachment",
        data: params,
        method: "post",
        responseType: "blob"
      });
    }
  },
  //V016_意向把握シート画面
  //V016-1_当初意向・最新の意向登録画面
  IntentHearing: {
    //V016初期表示
    indexIntentHearing(params) {
      return request({
        url: "/intentHearing/indexIntentHearing",
        data: params,
        method: "post"
      });
    },
    //比較・推奨チェック-チェックを入た場合
    checkIntentionProduct(params) {
      return request({
        url: "/intentHearing/checkIntentionProduct",
        data: params,
        method: "post"
      });
    },
    //比較・推奨チェック-チェックを外した場合
    uncheckIntentionProduct(params) {
      return request({
        url: "/intentHearing/uncheckIntentionProduct",
        data: params,
        method: "post"
      });
    },
    //提案チェック-チェックを外した場合
    uncheckProposalProduct(params) {
      return request({
        url: "/intentHearing/uncheckProposalProduct",
        data: params,
        method: "post"
      });
    },
    //申込チェック変更時の処理
    checkContractFlag(params) {
      return request({
        url: "/intentHearing/checkContractFlag",
        data: params,
        method: "post"
      });
    },
    //比較・推奨商品コピークリック時の処理
    copyIntentionProduct(params) {
      return request({
        url: "/intentHearing/copyIntentionProduct",
        data: params,
        method: "post"
      });
    },
    //V016-2_比較・推奨商品備考登録ダイアログ初期表示
    indexMemoEdit(params) {
      return request({
        url: "/intentHearing/indexMemoEdit",
        data: params,
        method: "post"
      });
    },
    //V016-2_比較・推奨商品備考登録ダイアログ更新
    updateMemoEdit(params) {
      return request({
        url: "/intentHearing/updateMemoEdit",
        data: params,
        method: "post"
      });
    },
    //V016-3_特記事項登録ダイアログ初期表示
    indexSpecialAffairEdit(params) {
      return request({
        url: "/intentHearing/indexSpecialAffairEdit",
        data: params,
        method: "post"
      });
    },
    //V016-3_特記事項登録ダイアログ更新
    updateSpecialAffairEdit(params) {
      return request({
        url: "/intentHearing/updateSpecialAffairEdit",
        data: params,
        method: "post"
      });
    },
    //V016-1当初意向初期表示
    indexOriginalEdit(params) {
      return request({
        url: "/intentHearing/indexOriginalEdit",
        data: params,
        method: "post"
      });
    },
    //V016-1当初意向新規登録
    insertOriginal(params) {
      return request({
        url: "/intentHearing/insertOriginal",
        data: params,
        method: "post"
      });
    },
    //V016-1当初意向更新
    updateOriginal(params) {
      return request({
        url: "/intentHearing/updateOriginal",
        data: params,
        method: "post"
      });
    },
    //V016-1最新の意向初期表示
    indexLatestEdit(params) {
      return request({
        url: "/intentHearing/indexLatestEdit",
        data: params,
        method: "post"
      });
    },
    //V016-1最新意向更新
    updateLatest(params) {
      return request({
        url: "/intentHearing/updateLatest",
        data: params,
        method: "post"
      });
    }
  },
  //V017_意向把握シート（最終確認）画面
  IntentConfirm: {
    //初期表示
    indexIntentConfirm(params) {
      return request({
        url: "/intentConfirm/indexIntentConfirm",
        data: params,
        method: "post"
      });
    },
    //完了(b4)ボタンクリック時の処理
    insertFinalIntent(params) {
      return request({
        url: "/intentConfirm/insertFinalIntent",
        data: params,
        method: "post"
      });
    },
    //リモート署名ボタンクリック時の処理
    insertFinalIntentAndmakeRemoteSignUrl(params) {
      return request({
        url: "/intentConfirm/insertFinalIntentAndmakeRemoteSignUrl",
        data: params,
        method: "post"
      });
    },
    //承認(b7)ボタンクリック時の処理
    updateAdmitIntention(params) {
      return request({
        url: "/intentConfirm/updateAdmitIntention",
        data: params,
        method: "post"
      });
    },
    //意向把握申請の差戻画面（V017-4）の初期表示
    indexReturnIntention(params) {
      return request({
        url: "/intentConfirm/indexReturnIntention",
        data: params,
        method: "post"
      });
    },
    //差戻(b42)ボタンクリック時の処理
    updateReturnIntention(params) {
      return request({
        url: "/intentConfirm/updateReturnIntention",
        data: params,
        method: "post"
      });
    },
    //V017-5_商品情報登録ダイアログ呼び出し時の処理（画面表示）
    indexProductInfoEdit(params) {
      return request({
        url: "/intentConfirm/indexProductInfoEdit",
        data: params,
        method: "post"
      });
    },
    //V017-5_商品情報登録ダイアログの登録（b52）ボタンクリック時の処理
    updateProductInfoEdit(params) {
      return request({
        url: "/intentConfirm/updateProductInfoEdit",
        data: params,
        method: "post"
      });
    },
    // V017-6特記事項登録ダイアログの処理（画面表示）
    indexSpecialAffairEdit(params) {
      return request({
        url: "/intentConfirm/indexSpecialAffairEdit",
        data: params,
        method: "post"
      });
    },
    //V017-6特記事項登録ダイアログの登録ボタンクリック時の処理
    updateSpecialAffairEdit(params) {
      return request({
        url: "/intentConfirm/updateSpecialAffairEdit",
        data: params,
        method: "post"
      });
    }
  },
  //V018_提案商品登録画面
  ProposalProductEdit: {
    //初期表示
    indexProposalProcessEdit(params) {
      return request({
        url: "/proposalProductEdit/indexProposalProductEdit",
        data: params,
        method: "post"
      });
    },
    //提案商品リスト
    searchTenantProductList(params) {
      return request({
        url: "/proposalProductEdit/searchTenantProductList",
        data: params,
        method: "post"
      });
    },
    //特約リスト
    searchProposalSpecialList(params) {
      return request({
        url: "/proposalProductEdit/searchProposalSpecialList",
        data: params,
        method: "post"
      });
    },
    //契約者(i16)変更時の処理
    contractCustomerChange(params) {
      return request({
        url: "/proposalProductEdit/contractCustomerChange",
        data: params,
        method: "post"
      });
    },
    //削除
    deleteProposalProduct(params) {
      return request({
        url: "/proposalProductEdit/deleteProposalProduct",
        data: params,
        method: "post"
      });
    },
    //新規登録
    insertProposalProduct(params) {
      return request({
        url: "/proposalProductEdit/insertProposalProduct",
        data: params,
        method: "post"
      });
    },
    //編集
    updateProposalProduct(params) {
      return request({
        url: "/proposalProductEdit/updateProposalProduct",
        data: params,
        method: "post"
      });
    }
  },
  //V022_案件検索画面
  ProposalSearch: {
    //初期表示
    indexProposalSearch(params) {
      return request({
        url: "/proposalSearch/indexProposalSearch",
        data: params,
        method: "post"
      });
    },
    //部署のリストを更新します
    searchDepartmentList(params) {
      return request({
        url: "/proposalSearch/searchDepartmentList",
        data: params,
        method: "post"
      });
    },
    //商品のリストを更新します
    searchProductList(params) {
      return request({
        url: "/proposalSearch/searchProductList",
        data: params,
        method: "post"
      });
    },
    //案件検索
    searchProposalSearchList(params) {
      return request({
        url: "/proposalSearch/searchProposalSearchList",
        data: params,
        method: "post"
      });
    },
    //担当者変更ダイアログ 初期表示
    indexBatchStaffEdit(params) {
      return request({
        url: "/proposalSearch/indexBatchStaffEdit",
        data: params,
        method: "post"
      });
    },
    //担当者変更
    batchStaffEdit(params) {
      return request({
        url: "/proposalSearch/batchStaffEdit",
        data: params,
        method: "post"
      });
    },
    //見送り登録ダイアログ 初期表示
    indexBatchInsertForegoEdit(params) {
      return request({
        url: "/proposalSearch/indexBatchInsertForegoEdit",
        data: params,
        method: "post"
      });
    },
    //見送り登録
    batchInsertForegoEdit(params) {
      return request({
        url: "/proposalSearch/batchInsertForegoEdit",
        data: params,
        method: "post"
      });
    },
    //取消登録ダイアログ 初期表示
    indexBatchCancelForegoEdit(params) {
      return request({
        url: "/proposalSearch/indexBatchCancelForegoEdit",
        data: params,
        method: "post"
      });
    },
    //取消登録
    batchCancelForegoEdit(params) {
      return request({
        url: "/proposalSearch/batchCancelForegoEdit",
        data: params,
        method: "post"
      });
    },
    //取消登録
    indexBatchInsertDueForegoEdit(params) {
      return request({
        url: "/proposalSearch/indexBatchInsertDueForegoEdit",
        data: params,
        method: "post"
      });
    },
    //取消登録
    batchInsertDueForegoEdit(params) {
      return request({
        url: "/proposalSearch/batchInsertDueForegoEdit",
        data: params,
        method: "post"
      });
    },
    // V039_顧客条件抽出画面 データ存在チェック
    checkSelectUserId(params) {
      return request({
        url: "/recruitmentTargetExtract/checkSelectUserId",
        data: params,
        method: "post"
      });
    }
  },
  //V081_案件基本情報登録画面
  ProposalBasicInfoEdit: {
    //初期表示
    indexProposalBasicInfoEdit(params) {
      return request({
        url: "/proposalBasicInfoEdit/indexProposalBasicInfoEdit",
        data: params,
        method: "post"
      });
    },
    //部署(i8)のリストを更新します
    searchDepartmentList(params) {
      return request({
        url: "/proposalBasicInfoEdit/searchDepartmentList",
        data: params,
        method: "post"
      });
    },
    //証券番号(i10)の選択リストの取得
    searchPolicyList(params) {
      return request({
        url: "/proposalBasicInfoEdit/searchPolicyList",
        method: "post",
        data: params
      });
    },
    //新規登録
    insertProposalBasicInfo(params) {
      return request({
        url: "/proposalBasicInfoEdit/insertProposalBasicInfo",
        method: "post",
        data: params
      });
    },
    //更新
    updateProposalBasicInfo(params) {
      return request({
        url: "/proposalBasicInfoEdit/updateProposalBasicInfo",
        method: "post",
        data: params
      });
    },
    //削除
    deleteProposalBasicInfo(params) {
      return request({
        url: "/proposalBasicInfoEdit/deleteProposalBasicInfo",
        method: "post",
        data: params
      });
    }
  },
  //V082_案件プロセス登録画面
  ProposalProcessEdit: {
    //初期表示
    indexProposalProcessEdit(params) {
      return request({
        url: "/proposalProcessEdit/indexProposalProcessEdit",
        data: params,
        method: "post"
      });
    },
    updateProposalProcessEdit(params) {
      return request({
        url: "/proposalProcessEdit/updateProposalProcessEdit",
        data: params,
        method: "post"
      });
    },
    insertIntent(params) {
      return request({
        url: "/proposalProcessEdit/insertIntent",
        data: params,
        method: "post"
      });
    },
    insertProduct(params) {
      return request({
        url: "/proposalProcessEdit/insertProduct",
        data: params,
        method: "post"
      });
    }
  },
  //V083_添付ファイル登録画面
  ProposalAttachmentEdit: {
    //初期表示
    indexProposalAttachmentEdit(params) {
      return request({
        url: "/proposalAttachmentEdit/indexProposalAttachmentEdit",
        data: params,
        method: "post"
      });
    },
    //登録(b2)クリック時の処理
    insertProposalAttachmentEdit(params) {
      return request({
        url: "/proposalAttachmentEdit/insertProposalAttachmentEdit",
        data: params,
        method: "post"
      });
    }
  },
  //V096_満期更改案件一括登録画面
  DueProposalBatchCreation: {
    //初期表示
    indexDueProposalBatchCreation(params) {
      return request({
        url: "/dueProposalBatchCreation/indexDueProposalBatchCreation",
        data: params,
        method: "post"
      });
    },
    //一括登録
    insertDueProposalBatchCreation(params) {
      return request({
        url: "/dueProposalBatchCreation/insertDueProposalBatchCreation",
        data: params,
        method: "post"
      });
    }
  },
  //V098_意向把握シート検索画面
  IntentConfirmSearch: {
    //初期表示
    indexIntentConfirmSearch(params) {
      return request({
        url: "/intentConfirmSearch/indexIntentConfirmSearch",
        data: params,
        method: "post"
      });
    },
    //検索（b1）をクリックしたときの処理
    searchIntentConfirmSearchList(params) {
      return request({
        url: "/intentConfirmSearch/searchIntentConfirmSearchList",
        data: params,
        method: "post"
      });
    },
    //差戻（b14）をクリックしたときの処理
    returnIntentConfirmSearch(params) {
      return request({
        url: "/intentConfirmSearch/returnIntentConfirmSearch",
        data: params,
        method: "post"
      });
    },
    //一括承認（b12）をクリックしたときの処理
    admitIntentConfirmSearch(params) {
      return request({
        url: "/intentConfirmSearch/admitIntentConfirmSearch",
        data: params,
        method: "post"
      });
    }
  }
};
